import * as React from "react";

// import { Link } from 'react-router-dom';
import { Button, Col, Form, FormGroup, Input, Label, Row } from "reactstrap";

// icons
import "font-awesome/css/font-awesome.min.css";

// classes
import classes from "classnames";

// styling
import "bootstrap/dist/css/bootstrap.min.css";
import "./onBoardingCommon.css";

// toast
import "react-toastify/dist/ReactToastify.css";

// components
import Loader from "react-loader";
import NavBar from "../../components/CustomNav/CustomNav.Component";

// router
import { Redirect } from "react-router-dom";

// toast component
import { toast, ToastContainer } from "react-toastify";

import {
  createItemGen,
  currentBaseUrl,
  currentUser,
  getGeneralSmartTableData,
  isFirstLogIn,
  isUserLoggedIn
} from "../../common/services";

// offline online
import { Offline, Online } from "react-detect-offline";
import { CSSTransition } from "react-transition-group";

import logo from '../../assets/images/plex_new.png';

class SetProfilePage extends React.Component {
  public state = {
    baseurl: currentBaseUrl(),
    countries: [],
    date: new Date(),
    loaded: true,
    password: "",
    schools: [],
    toDashboard: false,
    toLogin: false,
    toSetAvatar: false,
    username: ""
  };

  constructor(props) {
    super(props);
    this.onLogout = this.onLogout.bind(this);
    this.handlesuccess = this.handlesuccess.bind(this);
    this.goToLogin = this.goToLogin.bind(this);
  }

  public goToLogin() {
    this.setState({ toLogin: true });
  }

  public handleGenSmartDataLoaded(key, objkey, res) {
    if (res.code === 200) {
      console.log(key);
      this.setState({ loaded: true });
      this.setState({ [key]: res.response[objkey] });
    }
    if (res.code === 401) {
      this.onLogout("arg");
      console.log("logout");
    }
  }

  public componentDidMount() {
    if (!isFirstLogIn() && isUserLoggedIn()) {
      this.setState({ toDashboard: true });
    } else if (isFirstLogIn() && isUserLoggedIn()) {
      this.setState({ toDashboard: false });

      getGeneralSmartTableData("admin/countries/overview_items/", text =>
        this.handleGenSmartDataLoaded("countries", "countries", text)
      );

      getGeneralSmartTableData("admin/organisations/overview_items/", text =>
        this.handleGenSmartDataLoaded("schools", "schools", text)
      );
    } else {
      this.setState({ toLogin: true });
    }
  }

  public onLogout(arg) {
    console.log("logout");
    this.setState({ tologin: true });
  }

  public ProfileSubmit = event => {
    event.preventDefault();
    console.log("dummy");

    this.setState({ loaded: false });

    const item = {
      country: event.target.elements.country.value,
      school: event.target.elements.school.value
    };

    createItemGen("admin/userprofiles/init_profile/", item, text =>
      this.handleprofile(text)
    );
  };

  public onChange = date => this.setState({ date });

  public handlesuccess() {
    this.setState({ baseurl: currentBaseUrl() });
    this.setState({ toSetAvatar: true });
  }
  public handleprofile(res) {
    if (res.code === 200) {
      toast.success("Profile update successful");
      this.setState({ loaded: true });
      setTimeout(this.handlesuccess, 2000);
    } else if (res.code === 404) {
      this.setState({ loaded: true });
      toast.error("Operation failed, check details and try again");
      console.log(res);
    } else if (res.code === 400) {
      this.setState({ loaded: true });
      toast.error("Operation failed");
      console.log(res);
    }
  }

  public render() {
    if (this.state.toDashboard === true) {
      return <Redirect to={this.state.baseurl + "home"} />;
    }
    if (this.state.toLogin === true) {
      return <Redirect to="/login" />;
    }
    if (this.state.toSetAvatar === true) {
      return <Redirect to={this.state.baseurl + "setavatar"} />;
    }

    const countryfields = {
      id: "id",
      name: "Name"
    };
    return (
      <div>
        <NavBar logoutParent={this.onLogout} />
        <ToastContainer />
        <CSSTransition in={true} appear={true} classNames="fade" timeout={800}>
          <div className="initprofile-container">
            <div className="initprofile-content">
              <Row className="align-items-center">
                <Col xs="12" sm="12" md="12" lg="7" className="body-copy-block">
                  <p className="hello-username">
                    Hello <span> {currentUser()}</span>,
                    <br />
                    welcome to <img className="inline-logo" src={logo}/>, are you ready to win today</p>
                  <p className="please-tell-us-more">
                    Please tell us more about yourself so we can tailor your
                    experiance accordingly. In high school, the language I most
                    fell in love with happened to be a dead one: Latin. Sure,
                    it’s spoken at the Vatican, and when I first began to study
                    the tongue of Virgil and Catullus, friends joked that I
                    could only use it if I moved to Rome.
                  </p>
                </Col>
                <Col xs="12" sm="12" md="12" lg="5">
                  <Form
                    onSubmit={this.ProfileSubmit}
                    className="initprofile-form"
                  >

                    <Col xs="12">
                      <select
                        className = "custom-select"
                        placeholder="Country"
                        name="country"
                        required={true}
                      >
                        <option value="Country">Country</option>
                        {this.state.countries.map(d => (
                          <option
                            key={d[countryfields.id]}
                            value={d[countryfields.id]}
                          >
                            {d[countryfields.name]}
                          </option>
                        ))}
                      </select>
                    </Col>

                    <Col xs="12">

                    <input
                        className="custom-textfield"
                        name="school"
                        placeholder="School"
                        required={true}
                        data-arg="school"
                      />

                    </Col>

                    <Col xs="12" className="form-group-override">
                      <FormGroup>
                        <button
                          type="submit"
                          className="init-profile-submit-button blue-button"
                        >
                          CLICK ME
                        </button>
                        <Online>
                          <Loader loaded={this.state.loaded} />
                        </Online>
                        <Offline>
                          <i className="fa fa-bell">
                            You are currently offline
                          </i>
                        </Offline>
                      </FormGroup>
                    </Col>
                    <Col xs="12">
                      <div>
                        <a
                          // color="link"
                          className="skip-for-now"
                          onClick={this.goToLogin}
                        >
                          SKIP FOR NOW
                        </a>
                      </div>
                    </Col>
                  </Form>
                </Col>
              </Row>
            </div>
          </div>
        </CSSTransition>
      </div>
    );
  }
}

export default SetProfilePage;



// WEBPACK FOOTER //
// ./src/pages/Onboarding/setProfilePage.Component.tsx